<template>
	<div class="layout--full-page">
		<router-view />
	</div>
</template>

<script>
	import { initI18nTranslate } from "@/i18n";

	export default {
		async beforeCreate() {
			const branding = await this.$store.dispatch("branding");

			// Initialiser le plugin de traduction avec le nom du branding
			initI18nTranslate(this.$store.state.name);

			if (branding && branding.colors) {
				const root = document.documentElement;

				for (const [key, value] of Object.entries(branding.colors)) {
					root.style.setProperty(`--${key}`, value);
				}
			}
		}
	};
</script>
